module.exports = __webpack_public_path__ + "img/avatar.4e48ad70.png";